module.exports = __webpack_public_path__ + "media/images/application/social_sharing/twitter-ab2b55bd3f4bd81d7a9cfd7db24acde8.png";